<style lang="less" scoped>
  .pay-callback{
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100vh;
    .pay-status{
      text-align: center;
      font-size: 0;
      img{
        width: 37.6px;
        height: 37.4px;
        margin-top: 46.2px;
      }
      .status-text{
        font-size: 17px;
        color: #ff5000;
        margin: 12.4px 0 23px;
        font-weight: 550;
      }
    }
    .pay-status-message{
      font-size: 12px;
      color: #000000;
      margin-bottom: 26px;
    }
    .coupon-use-guide{
      position: relative;
      top: -50px;
      border: 1px solid #d2d2d2;
      padding-top: 64px;
      border-radius: 10px;
      width: 182vw;
      box-shadow: 4px 8px 24px 0px rgba(0, 0, 0, 0.12);
      transform: scale(0.5);
      .guide-title{
        background: rgba(255,255,255,1);
        padding: 24px 30px;
        border: 1px solid #d2d2d2;
        border-radius: 40px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        height: 36px;
        top: -24px;
        width: 10em;
      }
      .guide-title-text{
        font-size: 26px;
        color: #4a4a4a;
        margin: -64px 4px 2em;
        text-align: center;
        transform: translateZ(1px);
        background: #fff;
        border-radius: inherit;
      }
      .guide-stage{
        font-size: 24px;
        color: #4a4a4a;
        padding: 0 36px 48px;
      }
      .to-use-coupon{
        height: 102px;
        font-size: 30px;
        line-height: 102px;
        border-top: 1px solid #d2d2d2;
        color: #ff5000;
        text-align: center;
      }
    }
    .to-use-coupon-2{
      box-shadow: 2px 4px 12px 0px rgba(0, 0, 0, 0.12);
      width: 60vw;
      border: 1px solid #d2d2d2;
      border-radius: 6px;
      color: #ff5000;
      text-align: center;
      height: 44px;
      line-height: 44px;
      font-size: 15px;
      margin-top: 36px;
    }
  }
</style>

<template>
  <div class="pay-callback">
    <div class="pay-status">
      <img  class="status-icon" src="../../../../image/preorder/selected.png" />
      <div class="status-text" >支付成功</div>
    </div>
    <div class="pay-status-message" v-html="callbackText"></div>
    <div class="coupon-use-guide" v-if="callBackCouponText">
      <div class="guide-title"></div>
      <div class="guide-title-text">- 兑换步骤 -</div>
      <div class="guide-stage" v-html="callBackCouponText">
      </div>
      <div class="to-use-coupon" @click="toChange">
        立即兑换
      </div>
    </div>
    <div class="to-use-coupon-2" @click="toChange" v-if="!callBackCouponText">
      立即兑换
    </div>
    <load :visible="loading"></load>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import {
  MessageBox,
} from 'mint-ui'
import _ from 'underscore'
import CONSTANT from '../../../constant/coupon.js'
import CONSTANT_PAY from '../../../constant/pay.js'
import COMMON_CONST from '../../../constant/common.js'
import load from '../../../components/loading'
import { getHostName } from '../../../util/function.js'
import Appbridge from '@maizuo-fe/jk-appbridge'
import { app } from '../../../util/platform'

export default {
  data() {
    return {
      inter: {},
      queryTimes: 0,
      loading: true,
      callbackText: '',
      callBackCouponText: '',
      isNeedCheckPay: true,
    }
  },
  components: {
    load,
  },
  methods: {
    ...mapActions([
      'getTextForShow',
      'getOrderPayStatus',
      'checkPayStatus',
    ]),
    toChange() {
      location.href = COMMON_CONST.MZMOVIE_HOST
    },
    toOrderDetail() {
      if(app.isMZFilm()) {
        return Appbridge.redirect('orders')
      }
      return window.location.href = `${location.protocol}//${location.hostname}/v5/#/user/order/${this.payOrderId}?type=1`
    },
    checkOrderStatus() {
      this.inter = setInterval(() => {
        this.getOrderPayStatus({
          payType: this.payType,
          payOrderId: this.payOrderId,
        }).then(() => {
          clearInterval(this.inter)
          this.loading = false
        })

        this.queryTimes += 1

        if (this.queryTimes > 20) {
          clearInterval(this.inter)
          // this.loading = false
          MessageBox({
            message: '暂时无法获取订单支付状态，请稍候查看',
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: '查看订单',
          }).then(action => {
            this.toOrderDetail()
          });
        }
      }, 1000)
    },
  },
  computed: {
    payOrderId() {
      return this.$route.query.payOrderId
    },
    activeCode() {
      return this.$route.query.activeCode
    },
    payType() {
      return this.$route.query.payType
    },
  },
  mounted() {
    this.getTextForShow({
      activeCode: this.activeCode,
      typeList: [CONSTANT.TEXT_TYPE_CALLBACK, CONSTANT.TEXT_TYPE_CALLBACK_COUPON_EXCHANGE]
    }).then(data => {
      this.callbackText = _.find(data.copyList, text => {
        return text.type === CONSTANT.TEXT_TYPE_CALLBACK
      }).copy
      this.callBackCouponText = _.find(data.copyList, text => {
        return text.type === CONSTANT.TEXT_TYPE_CALLBACK_COUPON_EXCHANGE
      }).copy.replace(/<p><br><\/p>/g, '')
    })
    if(this.paytype==CONSTANT_PAY.PAY_TYPE_NO_CASH){
      //如果支付方式为纯余额或者为纯卡支付，则不查询
      this.loading = false
      return 
    }
    this.checkOrderStatus()
  }
}
</script>
